/**
 * GetCasinoInsights data refreshes server-side at :05 and :35 each hour
 * (two half-hour periods). Period boundaries for freshness:
 *
 * - :05:00 → :34:59.999  → period start = today HH:05
 * - :35:00 → :59:59.999  → period start = today HH:35
 * - :00:00 → :04:59.999  → period start = previous hour's :35
 */

/** Most recent :05 or :35 boundary at or before `now`. */
export function getInsightDataPeriodStart(now: Date): Date {
  const d = new Date(now.getTime());
  const minutes = d.getMinutes();
  if (minutes < 5) {
    d.setHours(d.getHours() - 1);
    d.setMinutes(35, 0, 0);
  } else if (minutes < 35) {
    d.setMinutes(5, 0, 0);
  } else {
    d.setMinutes(35, 0, 0);
  }
  return d;
}

/** Parse API update timestamps; invalid / empty → null. */
export function parseInsightUpdateDate(value: unknown): Date | null {
  if (value === null || value === undefined || value === '') return null;
  const d = value instanceof Date ? value : new Date(String(value));
  const t = d.getTime();
  return Number.isFinite(t) ? d : null;
}

/**
 * True when `lastUpdated` is on or after the current period start
 * (data belongs to the open half-hour window).
 */
export function isUpdateDateInCurrentPeriod(
  lastUpdated: unknown,
  now: Date = new Date()
): boolean {
  const updated = parseInsightUpdateDate(lastUpdated);
  if (!updated) return false;
  return updated.getTime() >= getInsightDataPeriodStart(now).getTime();
}

/** Pull freshness timestamp from a GetCasinoInsights envelope. */
export function getInsightResponseUpdateDate(resp: {
  updateDate?: unknown;
  last_updated?: unknown;
  lastUpdated?: unknown;
}): string | null {
  const raw = resp?.updateDate ?? resp?.last_updated ?? resp?.lastUpdated ?? null;
  const parsed = parseInsightUpdateDate(raw);
  return parsed ? parsed.toISOString() : raw != null && raw !== '' ? String(raw) : null;
}
